export const webFonts = [
  "Roboto",
  "OpenSans",
  "Lato",
  "Montserrat",
  "Oswald",
  "Raleway",
  "Slabo27px",
  "Merriweather",
  "Ubuntu",
  "PTSans",
  "NotoSans",
  "PlayfairDisplay",
  "Poppins",
  "SourceSansPro",
  "DancingScript",
];
